import { StringConstants } from "global/constants/StringConstants";

class UrlConstants extends StringConstants {
  PROD = false;

  url_prod = "https://api.panaceainsights.com/api/v1";
  url_dev = "https://uat-api.panaceainsights.com/api/v1";

  url = this.PROD ? this.url_prod : this.url_dev;

  //use common name of APIs
  public = "public";
  person = "person";
  auth = "auth";

  // authentication APIs
  LOGIN = `${this.url}/${this.public}/login`;
  SIGNUP = `${this.url}/${this.public}/sign-up`;
  VALIDATE_OTP = `${this.url}/${this.auth}/validate-otp`;
  RESEND_OTP = `${this.url}/${this.auth}/resend-otp`;
  FORGOT_PASSWORD = `${this.url}/${this.public}/forgot-password`;
  SUBSCRIBE = `${this.url}/${this.public}/subscribe`;
  CONTACT_US = `${this.url}/${this.public}/contact-us`;

  // public APIs
  REFRESHTOKEN = "";
  webhook_URL = "";
  getAllBlogs = `${this.url}/blog/all`;
  getBlogById = `${this.url}/blog/get-blog?blog_id=`;
  blogComments = `${this.url}/blog/`;
  likeDislikeBlog = `${this.url}/blog/like-blog`;
  generatedBlogsList = `${this.url}/blog/reviewed-blogs`;
  generateBlog = `${this.url}/blog/generate-with-response`;
}

let urls = new UrlConstants();
export default urls;
